

import {
  Employee,
} from "@/model/Employee";

import Vue,
{
  PropType,
} from "vue";

import {
  HelperFunctions
} from "@/scripts/Common/HelperFunctions";

import type {
  Person,
} from "@/scripts/Common";

import VueI18n from "vue-i18n";

export default Vue.extend({
  props: {
    label: {
      required: true,
      type: String as PropType<string | VueI18n.TranslateResult>,
    },
    model: {
      required: true,
      type: Object as PropType<Person | Employee>
    },
    HasNoEditRights: Boolean,
    expanded: {
      required: false,
      type: Array as PropType<Array<number>>,
      default() {
        return [1]
      }
    },
  },
  data: function () {
    return {
      valid: true,
      internalExpand: this.expanded,
    };
  },
  computed: {
    rules() {
      return {
        required: (value: string) =>
          !!value || this.$t("Rules.Required"),
        max: (maxLength: number, value: string) =>
          (!!value && value.length <= maxLength) ||
          this.$t("Rules.Max", {maxLength: maxLength}),
        email: (value: string) =>
          (!!value && HelperFunctions.IsEmailValid(value)) ||
          this.$t("Rules.FormatNotValid"),
      };
    }
  },
  methods: {
    validate() {
      (this.$refs.form as any).validate();
    },
    resetValidation() {
      (this.$refs.form as any).resetValidation();
    },
  },
  watch: {
    valid: function (value) {
      this.validate();
      this.$emit("ValidChanged", value);
    },
    expanded: function (value){
      this.internalExpand = value;
    }
  },
});
